import { render, staticRenderFns } from "./Detalhamento.vue?vue&type=template&id=8ebf87f2&"
import script from "./Detalhamento.vue?vue&type=script&lang=js&"
export * from "./Detalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports